import {combineReducers} from 'redux'
import QueryReducer from './QueryReducer'
import AuthorizationReducer from './AuthorizationReducer'


const RootReducer = combineReducers({
    Query: QueryReducer,
    Authorization:AuthorizationReducer
})

export default RootReducer